/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Nda_Downloaded14Inputs */

const en_coinvestments_audit_event_nda_downloaded14 = /** @type {(inputs: Coinvestments_Audit_Event_Nda_Downloaded14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA Downloaded`)
};

/**
* | output |
* | --- |
* | "NDA Downloaded" |
*
* @param {Coinvestments_Audit_Event_Nda_Downloaded14Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_nda_downloaded14 = /** @type {((inputs?: Coinvestments_Audit_Event_Nda_Downloaded14Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Nda_Downloaded14Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_nda_downloaded14(inputs)
});
export { coinvestments_audit_event_nda_downloaded14 as "coInvestments_audit_event_NDA_DOWNLOADED" }